import { useSelector } from "react-redux";

import FloorplanCard from "../FloorplanCard/FloorplanCard";

import styles from "./FloorPlanList.module.css";

export default function FloorplanList() {
    const floorPlans = useSelector((state) => state.visualizer.floorPlanData);
    const appliedFilters = useSelector(state => state.visualizer.appliedFilters);
    var sqft = [];
    var beds = [];
    var baths = [];
    var communities = [];
    var houseTypes = [];

    
    appliedFilters.forEach(f => {
        if(f["name"] === "squareFeet"){
            if(f["value"] !== 'all')
                var sqfts = f["value"].split('-');
                sqft.push([parseInt(sqfts[0]),parseInt(sqfts[1])])
        } 
        if(f["name"] === "beds"){
            if(f["value"] !== 'all')
                beds.push(parseInt(f["value"]))
        } 
        if(f["name"] === "baths"){
            if(f["value"] !== 'all')
                baths.push(parseInt(f["value"]))
        } 
        if(f["name"] === "communities"){
            if(f["value"] !== 'all')
                communities.push(f["value"])
        } 
        if(f["name"] === "houseType"){
            if(f["value"] !== 'all')
                houseTypes.push(f["value"])
        }
    });
    const shouldShow = (plan) => {
        const withinSqft = sqft.some(range => plan.sqft >= range[0] && plan.sqft <= range[1]);
        return (withinSqft || !sqft.length) &&
        (beds.includes(plan.beds) || !beds.length)  && 
        (baths.includes(plan.baths) || !baths.length) &&
        (communities.every(community => plan.community.includes(community)) || !communities.length) &&
        (houseTypes.includes(plan.type) || !houseTypes.length)
    };

    const floorplanList = floorPlans.filter(shouldShow).map((plan) => (
        <FloorplanCard
            key={plan.id}
            id={plan.id}
            floorplan={plan.name}
            defaultScene={`https://core2render.chameleonpower.com/cham/GetImage.ashx?spec=${plan.exterior}&sel=${plan.exteriorSel}&type=base&size=300`}
            beds={plan.beds}
            baths={plan.baths}
            sqft={plan.sqft}
            cars={plan.cars}
            type={plan.type}
            community={plan.community}
        />
    ));

    return (
        <section className={styles.container}>
            <div>
            {floorplanList}
            </div>
        </section>
    );
}
